import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createInvite, inviteWorker } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import type { InviteFormValues } from "../schemas/invite-schema";

export type CreateInviteInput = InviteFormValues & { workerId?: string };

export function useCreateInvite() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (input: CreateInviteInput) => {
			if (input.workerId) {
				if (!activeCanteiroId) {
					return Promise.reject(
						new Error("Selecione um canteiro antes de convidar uma pessoa."),
					);
				}
				return inviteWorker(activeCanteiroId, input.workerId, {
					email: input.email,
					role: input.role,
				});
			}
			if (input.scope === "worksite" && !activeCanteiroId) {
				return Promise.reject(
					new Error("Selecione um canteiro antes de convidar para o canteiro."),
				);
			}
			return createInvite({
				email: input.email,
				role: input.role,
				worksiteId:
					input.scope === "org" ? undefined : (activeCanteiroId ?? undefined),
			});
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["invites"] });
		},
	});
}
